<template>
  <div class="particles-js" style="position: fixed;display: block;">
    <vue-particles color="#dedede"></vue-particles>
  </div>
</template>

<script>
export default {
  name: "Particles",
  data() {
    return {
      show: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 1);
  }
};
</script>

<style >
.particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
}

canvas {
  display: block;
  vertical-align: bottom;
}
</style>
